import { lazy } from 'react';

export const HomePage = lazy(() => import('./HomePage'));
export const CompanyPage = lazy(() => import('./CompanyPage'));
export const ServicePage = lazy(() => import('./ServicePage'));
export const KampoPage = lazy(() => import('./KampoPage'));
export const ShichusuimeiPage = lazy(() => import('./ShichusuimeiPage'));
export const ContactPage = lazy(() => import('./ContactPage'));
export const NotFoundPage = lazy(() => import('./NotFoundPage'));
